export default {"src":"/_next/static/media/call.888f177a.svg","height":200,"width":200};